const ACTION_PREFIX = 'notification';
export const NotificationActionTypes = {
  ADD_NOTIFICATION: `${ACTION_PREFIX}/ADD_NOTIFICATION`,
  REMOVE_NOTIFICATION: `${ACTION_PREFIX}/REMOVE_NOTIFICATION`,
};

export function addNotification(message, level = 'success') {
  return {
    type: NotificationActionTypes.ADD_NOTIFICATION,
    message,
    level,
  };
}

export function removeNotification() {
  return {
    type: NotificationActionTypes.REMOVE_NOTIFICATION,
  };
}

export const NotificationActions = {
  addNotification,
  removeNotification,
};
